import React from 'react';
import './MarketsIntro.css';

const MarketsIntro = () => {
  return (
    <section className="markets-intro-section">
      <div className="markets-intro-container">
        <div className="section-header">
          <h2>Explore the Markets</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          CRISHI is a gateway to the world of insights spanning diverse crop markets, providing 800+ price assessments across 40+ countries.
        </p>
      </div>
    </section>
  );
};

export default MarketsIntro;